if (!customElements.get('outlet-drawer')) {
  class OutletDrawer extends HTMLElement {
    constructor() {
      super();

      this.trigger = document.getElementById('OutletDrawer-Trigger');
      this.overlay = this.querySelector('.cart-drawer__overlay');
      this.closeButton = this.querySelector('[data-outlet-close]');
      this.drawerInner = this.querySelector('.drawer__inner');

      this.handleEscape = this.handleEscape.bind(this);
    }

    connectedCallback() {
      if (document.body && this.parentNode !== document.body) {
        document.body.appendChild(this);
      }

      if (this.trigger) {
        this.trigger.addEventListener('click', () => this.open());
      }

      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.close());
      }

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.close());
      }
    }

    open() {
      this.classList.add('active');
      document.body.classList.add('overflow-hidden');

      if (this.drawerInner) {
        this.drawerInner.focus();
      }

      document.addEventListener('keyup', this.handleEscape);
    }

    close() {
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      document.removeEventListener('keyup', this.handleEscape);

      if (this.trigger) {
        this.trigger.focus();
      }
    }

    handleEscape(event) {
      if (event.code.toUpperCase() === 'ESCAPE') {
        this.close();
      }
    }
  }

  customElements.define('outlet-drawer', OutletDrawer);
}